import { Component } from '@angular/core';

@Component({
  selector: 'edm-menuitem-layout',
  template: `
    <ngx-one-column-layout>
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
  `,
  standalone: false,
})
export class MenuItemLayoutComponent {}
